<template lang="pug">
el-collapse#card-dados-territorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit(`laudoTecnicoAgricola:removerTerritorio`, territorio.id)'
                )

        el-form.form.p-2(
            label-position='top',
            size='small',
            ref='tecnico-agricola-form-dados-territorio'
        )
            el-form-item.emitente
                .label(slot='label')
                    span {{ $t('laudos.emitentePessoa') }}
                    span(v-show='territorio.representantes.length === 0') - {{ $t('laudos.nenhumEmitentePessoaVinculado') }}
                    span.erro(
                        v-if='$v.nomeEmitente.$invalid && $v.cpfCnpjEmitente.$invalid'
                    ) *
                el-radio(
                    v-for='(emitente, index) in territorio.representantes',
                    v-model='emitenteSelecionado',
                    :label='index',
                    :key='emitente.cpfCnpj'
                )
                    | {{ emitente.nomeRazaoSocial }} ({{ numeralStringFormatTocpfCnpj(emitente.cpfCnpj) }})
                    span.espacoRepresentante

                .outro
                    el-radio(
                        v-model='emitenteSelecionado',
                        :label='outroEmitente'
                    ) {{ $t('laudos.outro') }}:
                    .input
                        .nome
                            span {{ $t('laudos.emitentePessoa') }}
                            el-input(
                                :disabled='emitenteSelecionado !== outroEmitente',
                                v-model='outro.nome',
                                :placeholder='$t("laudos.insiraNomeOuRazaoSocialDoEmitenteProprietario")'
                            )
                        .cpfCnpj
                            span {{ $t('laudos.documentoDoEmitente') }}
                            span.erro *
                            el-input(
                                :disabled='emitenteSelecionado !== outroEmitente',
                                v-model='outro.cpfCnpj',
                                :placeholder='$t("laudos.documentoDoEmitente")',
                                :class='{ "erro-borda": !cpfCnpjEmitenteValido && emitenteSelecionado === outroEmitente }',
                                @change='aplicarMascara()'
                            )

            .credor
                el-form-item
                    .label(slot='label')
                        span {{ $t('laudos.nomeDoCredor') }}
                        span.erro(v-if='$v.nomeCredor.$invalid') *
                    el-input.nome(
                        v-model='nomeCredor',
                        :placeholder='$t("laudos.insiraNomeOuRazaoSocialDoCredor")'
                    )

                el-form-item
                    .label(slot='label')
                        span {{ $t('laudos.documentoDoCredor') }}
                        span.erro(
                            v-if='$v.cpfCnpjCredor.$invalid || !cpfCnpjCredorValido'
                        ) *
                    el-input.cpfCnpj(
                        v-model='cpfCnpjCredor',
                        :placeholder='$t("laudos.insiraDocumentoDoCredor")',
                        @change='aplicarMascaraCredor()'
                    )

            .dados
                .label.comarca-localidades-title(slot='label')
                    span {{ $t('laudos.comarca') }}
                    span.erro(v-if='$v.localidadeNivel2Selecionada.$invalid') *

                    div
                        el-form-item.form-localidades(
                            :title='$t("mensagens.blocoFiltros.uteis.ufMunicipio")',
                            name='localidadesNivel0'
                        )
                            .localidades-container(
                                v-loading='!localidadesNivel0.length'
                            )
                                div
                                    .mb-2
                                        span.localidade-title {{ $t('mensagens.comuns.pais') }}
                                        span.erro-localidade-nivel2(
                                            v-if='$v.localidadeNivel2Selecionada.$invalid'
                                        ) *
                                    el-select(
                                        v-model='localidadeNivel0Selecionada',
                                        filterable,
                                        value-key='id',
                                        @change='buscarLocalidadeNivel1()',
                                        :placeholder='$t("mensagens.comuns.selecione")'
                                    )
                                        el-option(
                                            v-for='(localidadeNivel0, index) in localidadesNivel0',
                                            :key='index',
                                            :label='localidadeNivel0.nome',
                                            :value='localidadeNivel0'
                                        ) {{ localidadeNivel0.nome }}
                                div
                                    .mb-2
                                        span.localidade-title {{ this.localidadeNivel0Selecionada?.sigla === 'BR' ? this.$t('mensagens.blocoFiltros.uteis.uf') : this.localidadeNivel0Selecionada.sigla === 'PY' ? this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel1') : this.$t('mensagens.blocoFiltros.uteis.argentinaNivel1') }}
                                        span.erro-localidade-nivel2(
                                            v-if='$v.localidadeNivel2Selecionada.$invalid'
                                        ) *
                                    el-select(
                                        v-model='localidadeNivel1Selecionada',
                                        filterable,
                                        value-key='id',
                                        @change='buscarLocalidadeNivel2()',
                                        :placeholder='$t("mensagens.comuns.selecione")'
                                    )
                                        el-option(
                                            v-for='(localidadeNivel1, index) in localidadesNivel1',
                                            :key='index',
                                            :label='localidadeNivel1.nome',
                                            :value='localidadeNivel1'
                                        ) {{ localidadeNivel1.nome }}
                                div
                                    .mb-2
                                        span.localidade-title {{ this.localidadeNivel0Selecionada?.sigla === 'BR' ? this.$t('mensagens.blocoFiltros.uteis.municipio') : this.localidadeNivel0Selecionada.sigla === 'PY' ? this.$t('mensagens.blocoFiltros.uteis.paraguaiNivel2') : this.$t('mensagens.blocoFiltros.uteis.argentinaNivel2') }}
                                        span.erro-localidade-nivel2(
                                            v-if='$v.localidadeNivel2Selecionada.$invalid'
                                        ) *
                                    el-select(
                                        v-model='localidadeNivel2Selecionada',
                                        filterable,
                                        value-key='id',
                                        :placeholder='$t("mensagens.comuns.selecione")'
                                    )
                                        el-option(
                                            v-for='(localidadeNivel2, index) in localidadesNivel2',
                                            :key='index',
                                            :label='localidadeNivel2.nome',
                                            :value='localidadeNivel2'
                                        ) {{ localidadeNivel2.nome }}
            .dados
                el-form-item
                    .label(slot='label')
                        span {{ $t('laudos.matriculas') }}
                        span.erro(v-if='$v.matriculas.$invalid') *
                    el-tag(
                        v-for='matricula in matriculas',
                        :key='matricula',
                        closable,
                        :disable-transitions='false',
                        @close='removerMatricula(matricula)'
                    )
                        | {{ matricula }}

                    el-input.input-new-tag(
                        v-if='adicionandoMatricula',
                        v-model='novaMatricula',
                        ref='saveTagInput',
                        size='mini',
                        @keyup.enter.native='adicionarMatricula',
                        @blur='adicionarMatricula'
                    )
                        i.el.el-icon-circle-plus-outline(
                            slot='suffix',
                            style='cursor: pointer',
                            @click='adicionarMatricula'
                        )

                    BaseButton.button-new-tag(
                        v-else,
                        size='small',
                        @click='mostrarCampoNovaMatricula'
                    )
                        | + {{ $t('laudos.adicionarMatricula') }}
</template>

<script>
import formatters from '@/modules/laudos/utils/formatters';
import validators from '@/modules/laudos/utils/validators';
import { required } from 'vuelidate/lib/validators';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';
import LocalidadeService from '@/modules/laudos/services/LocalidadeService';

const ID_OUTRO_EMITENTE = '42';

export default {
    name: 'CardDadosTerritorio',

    components: {
        BaseButton
    },

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapse: ['item'],
            outroEmitente: ID_OUTRO_EMITENTE,
            emitenteSelecionado: '',
            nomeEmitente: '',
            cpfCnpjEmitente: '',
            outro: {
                nome: '',
                cpfCnpj: ''
            },
            nomeCredor: '',
            cpfCnpjCredor: '',
            matriculas: [],
            cpfCnpjEmitenteValido: true,
            cpfCnpjCredorValido: false,
            adicionandoMatricula: true,
            novaMatricula: '',
            localidadesNivel0: [],
            localidadeNivel0Selecionada: {},
            tituloLocalidadeNivel1: this.$t('mensagens.blocoFiltros.uteis.uf'),
            localidadesNivel1: [],
            localidadeNivel1Selecionada: {},
            tituloLocalidadeNivel2: this.$t(
                'mensagens.blocoFiltros.uteis.municipio'
            ),
            localidadesNivel2: [],
            localidadeNivel2Selecionada: {}
        };
    },

    mounted() {
        if (this.territorio.representantes.length === 0) {
            this.emitenteSelecionado = ID_OUTRO_EMITENTE;
        }
        this.areaFinanciadaHa = this.territorio.areaHa
            .toFixed(2)
            .toString()
            .replace('.', ',');
        this.$emit('laudoTecnicoAgricola:atualizarValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
        this.buscarLocalidadeNivel0();
    },

    watch: {
        emitenteSelecionado: function () {
            // eslint-disable-next-line eqeqeq
            if (this.emitenteSelecionado != ID_OUTRO_EMITENTE) {
                this.nomeEmitente =
                    this.territorio.representantes[
                        this.emitenteSelecionado
                    ].nomeRazaoSocial;
                this.cpfCnpjEmitente =
                    this.territorio.representantes[
                        this.emitenteSelecionado
                    ].cpfCnpj;
            } else {
                this.nomeEmitente = '';
                this.cpfCnpjEmitente = '';
            }
        },

        'outro.nome': function () {
            this.nomeEmitente = this.outro.nome;
        },

        'outro.cpfCnpj': function () {
            this.cpfCnpjEmitenteValido = validators.validarDocumento(
                this.outro.cpfCnpj
            );
            this.cpfCnpjEmitente = this.cpfCnpjEmitenteValido
                ? this.outro.cpfCnpj
                : '';
        },

        cpfCnpjCredor: function () {
            this.cpfCnpjCredorValido = validators.validarDocumento(
                this.cpfCnpjCredor
            );
            this.gerarValidacao();
        },

        '$v.dados.$invalid': function () {
            this.gerarValidacao();
        },

        localidadeNivel0Selecionada: function () {
            if (Object.entries(this.localidadeNivel0Selecionada).length === 0) {
                this.localidadeNivel0Selecionada = this.localidadesNivel0[1];
                this.buscarLocalidadeNivel1();
            } else {
                this.localidadeNivel2Selecionada = null;
                this.localidadesNivel2 = [];
            }
        }
    },

    validations: {
        nomeEmitente: { required },
        cpfCnpjEmitente: { required },
        nomeCredor: { required },
        cpfCnpjCredor: { required },
        localidadeNivel2Selecionada: { required },
        matriculas: { required },

        dados: [
            'nomeEmitente',
            'cpfCnpjEmitente',
            'nomeCredor',
            'cpfCnpjCredor',
            'localidadeNivel2Selecionada',
            'matriculas'
        ]
    },

    methods: {
        numeralStringFormatTocpfCnpj(value) {
            return formatters.numeralStringFormatToDocumento(value);
        },

        cpfCnpjFormatToNumeral(value) {
            return formatters.documentoFormatToNumeral(value);
        },

        gerarValidacao() {
            this.$emit('laudoTecnicoAgricola:atualizarValidacao', {
                valido: !this.$v.dados.$invalid && this.cpfCnpjCredorValido,
                id: this.territorio.id
            });

            this.$emit('laudoTecnicoAgricola:atualizarDados', {
                dados: {
                    nomeRepresentante: this.nomeEmitente,
                    cpfCnpjRepresentante: this.cpfCnpjFormatToNumeral(
                        this.cpfCnpjEmitente
                    ),
                    tipoDocumentoRepresentante:
                        this.cpfCnpjEmitente.length < 11 ? 'RUC' : 'CPF_CNPJ',
                    territorioId: this.territorio.id,
                    tipoLaudoId: TipoLaudo.TECNICO_AGRICOLA,
                    nomeCredor: this.nomeCredor,
                    cpfCnpjCredor: this.cpfCnpjFormatToNumeral(
                        this.cpfCnpjCredor
                    ),
                    tipoDocumentoCredor:
                        this.cpfCnpjCredor.length < 11 ? 'RUC' : 'CPF_CNPJ',
                    matriculas: [...this.matriculas],
                    nivel2ComarcaId: this.localidadeNivel2Selecionada?.id
                },
                id: this.territorio.id
            });
        },

        removerMatricula(matricula) {
            this.matriculas.splice(this.matriculas.indexOf(matricula), 1);
        },

        mostrarCampoNovaMatricula() {
            this.adicionandoMatricula = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        adicionarMatricula() {
            const matricula = this.novaMatricula;
            if (matricula) {
                this.matriculas.push(matricula);
            }
            this.adicionandoMatricula = false;
            this.novaMatricula = '';
        },

        aplicarMascara() {
            this.outro.cpfCnpj = formatters.documentoFormatToNumeral(
                this.outro.cpfCnpj
            );
            this.outro.cpfCnpj = formatters.numeralStringFormatToDocumento(
                this.outro.cpfCnpj
            );
        },

        aplicarMascaraCredor() {
            this.cpfCnpjCredor = formatters.documentoFormatToNumeral(
                this.cpfCnpjCredor
            );
            this.cpfCnpjCredor = formatters.numeralStringFormatToDocumento(
                this.cpfCnpjCredor
            );
        },

        buscarLocalidadeNivel0() {
            LocalidadeService.findNivel0()
                .then(({ data }) => {
                    setTimeout(() => {
                        const localidadeNivel0Selecionada =
                            Object.entries(this.localidadeNivel0Selecionada)
                                .length === 0;

                        this.localidadesNivel0 = data;
                        if (localidadeNivel0Selecionada) {
                            this.localidadeNivel0Selecionada =
                                this.localidadesNivel0[0];
                            this.buscarLocalidadeNivel1();
                        }
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados dos países.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel1() {
            if (!this.localidadeNivel0Selecionada?.sigla) return;

            LocalidadeService.findNivel1(this.localidadeNivel0Selecionada.id)
                .then(({ data }) => {
                    this.localidadeNivel1Selecionada = null;
                    setTimeout(() => {
                        this.localidadesNivel1 = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de estados.'
                    );
                    throw error;
                });
        },

        buscarLocalidadeNivel2() {
            LocalidadeService.findNivel2(this.localidadeNivel1Selecionada.id)
                .then(({ data }) => {
                    this.localidadeNivel2Selecionada = null;
                    setTimeout(() => {
                        this.localidadesNivel2 = data;
                    }, 500);
                })
                .catch(error => {
                    this.exibirNotify(
                        'error',
                        'Não foi possível buscar os dados de municipio.'
                    );
                    throw error;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;
    width: 100% !important;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .form {
        .emitente .outro .input,
        .credor,
        .dados {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            gap: 16px;
            padding: 0px;
            width: 100% !important;
        }

        .emitente .outro .input {
            .nome {
                width: 66%;
            }

            .cpfCnpj {
                width: 33%;
            }
            .erro{
                color: red !important;
            }
        }

        .credor {
            .el-form-item--small:first-child {
                width: 66%;
            }

            .el-form-item--small:nth-child(2) {
                width: 33%;
            }
        }

        .dados {
            .el-input,
            .el-select {
                width: 250px;
            }
        }

        .el-radio {
            min-width: 0px !important;
        }
    }
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}

.erro-localidade-nivel2 {
    color: red !important;
    font-weight: normal;
}

.el-tag {
    margin-right: 10px;
}

.button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px !important;
    vertical-align: bottom;
}

.localidades-container {
    display: flex;
    justify-content: flex-start;
    gap: 25px;
    min-height: 60px;
}

.localidade-title {
    font-family: 'Roboto';
    font-weight: normal;
    margin-bottom: 0.5rem !important;
}

.comarca-localidades-title {
    font-weight: bold !important;
    color: var(--primary);
    font: 14px / 150% Roboto, sans-serif;
}
</style>
